import {
  SET_LANG,
  SET_CATEGORY_ENUMS,
  SET_SUB_CATEGORY_ENUMS,
  SET_COLOR_ENUMS,
  SET_YEAR_ENUMS,
  SET_BRAND_ENUMS,
  SET_MODEL_ENUMS,
  SET_GARAGE_ENUMS,
  SET_BRANCH_ENUMS,
  SET_PROVIDER_ENUMS,
  SET_FEATURES_ENUMS,
  SET_LICENSE_TYPE_ENUMS,
  SET_LANGUAGE_ENUMS,
  SET_NATIONALITY_ENUMS,
  SET_DRIVERS_AVAILABLE_NATIONALITY_ENUMS,
  SET_ADMINS_ENUMS,
  SET_ROLES_ENUMS,
  SET_DRIVER_LIST_ENUMS,
  SET_SERVICE_TYPE_ENUMS,
  SET_CLIENT_ENUMS,
  SET_CITY_ENUMS,
  SET_DAMAGE_LEVEL_ENUMS,
  SET_DAMAGE_AREA_ENUMS,
  SET_ACTIVE_ROLES_ENUMS,
  SET_BODY_DAMAGE_AREA_ENUMS,
  SET_USER_INFO,
  SET_CLIENT_INFO,
  SET_COMPANIES_ENUMS,
  SET_INSURANCE_COMPANY_ENUMS,
  SET_REGIONS_ENUMS,
  SET_PROVINCES_ENUMS,
  SET_ZONE_ENUMS,
  SET_POS_ENUMS,
  SET_MOBILE_ENUMS,
  SET_SERVICES_ENUMS,
  SET_DRIVER_AVAILABILITY,
  SET_VEHICLE_AVAILABILITY,
  SET_PROMO_CODE_ENUMS,
  SET_LTA_LIST_ENUMS,
  SET_CLIENT_TYPE_ENUMS,
  SET_ACCOUNT_ENUMS,
  SET_PROFORMA_INVOICE_ENUMS,
  SET_JV_ENUMS,
  SET_RESERVATION_LIST_ENUMS,
  SET_REMOTE_FINANCE_ACCOUNT_ENUMS,
  SET_TAX_TYPE_ENUMS,
  SET_TAX_TYPE_ZOHO_ENUMS,
  SET_OPERATOR,
  SET_TRAINING_TYPES_ENUMS,
  SET_TAX_TYPE_ODOO_ENUMS,
  SET_ODOO_REMOTE_FINANCE_ACCOUNT_ENUMS,
  SET_PRODUCT_ENUMS,
  SET_PRICING_LISTS_ENUMS,
  SET_TGA_TYPES_ENUMS,
  SET_RELIGION_ENUMS,
  SET_CLIENT_GRADE_ENUMS,
  SET_RESERVATION_CATEGORY_ENUMS,
  SET_SERVICE_CATEGORY_ENUMS,
  SET_CONTRACT_TYPE_ENUMS,
  SET_DRIVER_USERNAME_ENUMS,
  SET_CLIENT_USERNAME_ENUMS,
  SET_RESOURCE_REQUEST_USERNAME_ENUMS,
  SET_USER_ENUMS,
  SET_MISSING_REQUEST_PAYLOAD,
  SET_VEHICLE_TYPE_ENUMS,
  SET_BLANKET_ORDER_ENUMS,
  SET_KPI_REASON_ENUMS,
  SET_CLIENT_CITY_ENUMS,
  SET_CLIENT_COUNTRY_ENUMS,
  SET_MODEL_INCLUDED_ENUMS,
  SET_TOASTER_POP,
  SET_AVAILABLE_RESERVATION_LIST_ENUMS,
  SET_CHANGE_PASSWORD_TOKEN,
  SET_SHIFT_TYPE_ENUMS,
  SET_DRIVER_EMPLOYEE_ID,
  SET_CONTRACT_ID_ENUMS,
  SET_CONTRACT_ID_CLIENT_ENUMS,
  SET_PAYMENT_TYPES,
  SET_CLIENT_CONTACT_PERSON_ENUMS,
  SET_ENTITY_ENUMS,
  SET_USERNAME_ENUMS,
  SET_ADMIN_CONFIGURATION_ENUMS,
  SET_DRIVER_EMP_ID_ENUMS,
  SET_ROUTES_ENUMS,
  SET_WORKFLOW_ENUMS,
  SET_PROFORMA_INVOICE_NUMBER_ENUMS,
  SET_USER_NAME_ENUMS,
  SET_BLANKET_ORDER_ORDER_CODE_ENUMS,
  SET_SERVICE_POINT_ENUMS,
  SET_WATER_SOURCE_ENUMS,
  SET_BRANCH_GARAGE_ENUMS,
  SET_BRANCH_WATERSOURCE_ENUMS,
  SET_Certificates_of_Completion_ENUMS,
  // SET_TRIP_RATING_ENUMS,
  // SET_DRIVER_RATINGS_ENUMS,
  // SET_DRIVER_RATING_SUMMARY_ENUMS,
  SET_Certificate_of_Completion_BY_ID,
  SET_Certificate_Contract_Details_ENUMS,
  SET_Create_Certificate_Of_Completion_ENUMS,
  SET_Certificate_Of_Completion_PROFILE_ENUMS,
  SET_TRIP_COMPLETE_NOTE_ENUMS,
  SET_TRIP_RATING_ENUMS,
  SET_DRIVER_RATINGS_ENUMS,
  SET_DRIVER_RATING_SUMMARY_ENUMS,
  SET_Get_Contractors_Contracts,
  SET_Get_Tank_ENUMS,
  SET_AVAILABLE_ZONE_ENUMS,
  SET_Certificate_Logs,
  SET_Tanker_Type,
} from './mutations.type'


export default {
  [SET_LANG](state, result) {
    state.lang = result
  },
  [SET_CATEGORY_ENUMS](state, result) {
    state.category_enums = result
    state.sub_category_enums = []
  },
  [SET_SUB_CATEGORY_ENUMS](state, result) {
    state.sub_category_enums = result
  },
  [SET_COLOR_ENUMS](state, result) {
    state.color_enums = result
  },
  [SET_YEAR_ENUMS](state, result) {
    state.year_enums = result
  },
  [SET_BRAND_ENUMS](state, result) {
    state.brand_enums = result
    state.model_enums = []
  },
  [SET_MODEL_ENUMS](state, result) {
    state.model_enums = result
  },
  [SET_MODEL_INCLUDED_ENUMS](state, result) {
    state.model_included_enums = result
  },
  [SET_GARAGE_ENUMS](state, result) {
    state.garage_enums = result
  },
  [SET_BRANCH_ENUMS](state, result) {
    state.branch_enums = result
  },
  [SET_PROVIDER_ENUMS](state, result) {
    state.provider_enums = result
  },
  [SET_FEATURES_ENUMS](state, result) {
    state.features_enums = result
  },
  [SET_LICENSE_TYPE_ENUMS](state, result) {
    state.license_type_enums = result
  },
  [SET_LANGUAGE_ENUMS](state, result) {
    state.language_enums = result
  },
  [SET_NATIONALITY_ENUMS](state, result) {
    state.nationality_enums = result
  },
  [SET_DRIVERS_AVAILABLE_NATIONALITY_ENUMS](state, result) {
    state.drivers_available_nationality_enums = result
  },
  [SET_DRIVER_LIST_ENUMS](state, result) {
    state.driver_list_enums = result
  },
  [SET_ADMINS_ENUMS](state, result) {
    state.admins_enums = result
  },
  [SET_ROLES_ENUMS](state, result) {
    state.roles_enums = result
  },
  [SET_ACTIVE_ROLES_ENUMS](state, result) {
    state.active_roles_enums = result
  },
  [SET_SERVICE_TYPE_ENUMS](state, result) {
    state.services_type_list_enums = result
  },
  [SET_CLIENT_ENUMS](state, result) {
    state.clients_list_enums = result
  },
  [SET_CITY_ENUMS](state, result) {
    state.city_enums = result
  },
  [SET_DAMAGE_LEVEL_ENUMS](state, result) {
    state.damage_level_enums = result
  },
  [SET_DAMAGE_AREA_ENUMS](state, result) {
    state.damage_area_enums = result
  },
  [SET_BODY_DAMAGE_AREA_ENUMS](state, result) {
    state.body_damage_area_enums = result
  },
  [SET_USER_INFO](state, result) {
    state.user_info = result
    state.user_info_loaded = true
  },
  [SET_CLIENT_INFO](state, result) {
    state.client_info = result
  },
  [SET_COMPANIES_ENUMS](state, result) {
    state.companies_enums = result
  },
  [SET_INSURANCE_COMPANY_ENUMS](state, result) {
    state.insurance_company_enums = result
  },
  [SET_REGIONS_ENUMS](state, result) {
    state.regions_enums = result
  },
  [SET_PROVINCES_ENUMS](state, result) {
    state.provinces_enums = result
  },
  [SET_ZONE_ENUMS](state, result) {
    state.zone_enums = result
  },
  [SET_POS_ENUMS](state, result) {
    state.pos_enums = result
  },
  [SET_MOBILE_ENUMS](state, result) {
    state.mobile_enums = result
  },
  [SET_SERVICES_ENUMS](state, result) {
    state.services_enums = result
  },
  [SET_DRIVER_AVAILABILITY](state, result) {
    state.driver_availability = result
  },
  [SET_VEHICLE_AVAILABILITY](state, result) {
    state.vehicle_availability = result
  },
  [SET_PROMO_CODE_ENUMS](state, result) {
    state.promo_code_enums = result
  },
  [SET_LTA_LIST_ENUMS](state, result) {
    state.LTA_enums = result
  },
  [SET_CLIENT_TYPE_ENUMS](state, result) {
    state.clientType_enums = result
  },
  [SET_ACCOUNT_ENUMS](state, result) {
    state.account_enums = result
  },
  [SET_PROFORMA_INVOICE_ENUMS](state, result) {
    state.proforma_invoice_enums = result
  },
  [SET_JV_ENUMS](state, result) {
    state.JV_enums = result
  },
  [SET_RESERVATION_LIST_ENUMS](state, result) {
    state.reservation_list_enums = result
  },
  [SET_REMOTE_FINANCE_ACCOUNT_ENUMS](state, result) {
    state.remote_finance_account_enums = result
  },
  [SET_TAX_TYPE_ENUMS](state, result) {
    state.tax_type_enums = result
  },
  [SET_TAX_TYPE_ZOHO_ENUMS](state, result) {
    state.tax_type_zoho_enums = result
  },
  [SET_OPERATOR](state, result) {
    state.operator = result
  },
  [SET_TRAINING_TYPES_ENUMS](state, result) {
    state.training_type_enums = result
  },
  [SET_TAX_TYPE_ODOO_ENUMS](state, result) {
    state.tax_type_odoo_enums = result
  },
  [SET_ODOO_REMOTE_FINANCE_ACCOUNT_ENUMS](state, result) {
    state.odoo_remote_finance_account_enums = result
  },
  [SET_PRODUCT_ENUMS](state, result) {
    state.product_enums = result
  },
  [SET_PRICING_LISTS_ENUMS](state, result) {
    state.pricing_lists_enums = result
  },
  [SET_TGA_TYPES_ENUMS](state, result) {
    state.tga_type_enums = result
  },
  [SET_RELIGION_ENUMS](state, result) {
    state.religion_enums = result
  },
  [SET_CLIENT_GRADE_ENUMS](state, result) {
    state.client_grade_enums = result
  },
  [SET_RESERVATION_CATEGORY_ENUMS](state, result) {
    state.reservation_category_enums = result
  },
  [SET_SERVICE_CATEGORY_ENUMS](state, result) {
    state.service_category_enums = result
  },
  [SET_CONTRACT_TYPE_ENUMS](state, result) {
    state.contract_type_enums = result
  },
  [SET_DRIVER_USERNAME_ENUMS](state, result) {
    state.driver_username_enums = result
  },
  [SET_CLIENT_USERNAME_ENUMS](state, result) {
    state.client_username_enums = result
  },
  [SET_RESOURCE_REQUEST_USERNAME_ENUMS](state, result) {
    state.resource_request_username_enums = result
  },
  [SET_USER_ENUMS](state, result) {
    state.user_enums = result
  },
  [SET_MISSING_REQUEST_PAYLOAD](state, result) {
    state.missing_request_payload = result
  },
  [SET_VEHICLE_TYPE_ENUMS](state, result) {
    state.vehicle_type_enums = result
  },
  [SET_BLANKET_ORDER_ENUMS](state, result) {
    state.blanket_order_enums = result
  },
  [SET_KPI_REASON_ENUMS](state, result) {
    state.kpi_reason_enums = result
  },
  [SET_CLIENT_CITY_ENUMS](state, result) {
    state.client_city_enums = result
  },
  [SET_CLIENT_COUNTRY_ENUMS](state, result) {
    state.client_country_enums = result
  },
  [SET_TOASTER_POP](state, result) {
    state.toaster_message = result
  },
  [SET_AVAILABLE_RESERVATION_LIST_ENUMS](state, result) {
    state.available_reservation_list_enums = result
  },
  [SET_CHANGE_PASSWORD_TOKEN](state, result) {
    state.change_password_token = result
  },
  [SET_SHIFT_TYPE_ENUMS](state, result) {
    state.shift_type_enums = result
  },
  [SET_DRIVER_EMPLOYEE_ID](state, result) {
    state.driver_employee_id_list_enums = result
  },
  [SET_CONTRACT_ID_ENUMS](state, result) {
    state.contract_id_enums = result
  },
  [SET_CONTRACT_ID_CLIENT_ENUMS](state, result) {
    state.contract_id_client_enums = result
  },
  [SET_PAYMENT_TYPES](state, result) {
    state.payment_method_enums = result
  },
  [SET_CLIENT_CONTACT_PERSON_ENUMS](state, result) {
    state.client_contact_person_enums = result
  },
  [SET_ENTITY_ENUMS](state, result) {
    state.entity_enums = result
  },
  [SET_USERNAME_ENUMS](state, result) {
    state.username_enums = result
  },
  [SET_ADMIN_CONFIGURATION_ENUMS](state, result) {
    state.admin_configuration_enums = result
  },
  [SET_DRIVER_EMP_ID_ENUMS](state, result) {
    state.driver_employee_id_enums = result
  },
  [SET_ROUTES_ENUMS](state, result) {
    state.routes_enums = result
  },
  [SET_WORKFLOW_ENUMS](state, result) {
    state.workflow_enums = result
  },
  [SET_PROFORMA_INVOICE_NUMBER_ENUMS](state, result) {
    state.proforma_invoice_number_enums = result
  },
  [SET_USER_NAME_ENUMS](state, result) {
    state.user_name_enums = result
  },
  [SET_BLANKET_ORDER_ORDER_CODE_ENUMS](state, result) {
    state.blanket_order_order_code_enums = result
  },
  [SET_SERVICE_POINT_ENUMS](state, result) {
    state.service_point_enums = result
  },
  [SET_WATER_SOURCE_ENUMS](state, result) {
    state.water_source_enums = result
  },
  [SET_BRANCH_GARAGE_ENUMS](state, result) {
    state.branch_garage_enums = result
  },
  [SET_BRANCH_WATERSOURCE_ENUMS](state, result) {
    state.branch_watersource_enums = result
  },
  [SET_Certificates_of_Completion_ENUMS](state, result) {
    state.certificates_of_completion_enums = result
  },
  [SET_TRIP_COMPLETE_NOTE_ENUMS](state, result) {},
  [SET_TRIP_RATING_ENUMS](state, result) {
    state.trip_rating_enums = result
  },
  [SET_DRIVER_RATINGS_ENUMS](state, result) {
    state.driver_ratings_enums = result
  },
  [SET_DRIVER_RATING_SUMMARY_ENUMS](state, result) {
    state.driver_ratings_summary_enums = result
  },
  [SET_Certificate_of_Completion_BY_ID](state, result) {
    state.certificate_of_completion_by_id_enums = result
  },
  [SET_Certificate_Contract_Details_ENUMS](state, result) {
    state.certificate_contract_details_enmus = result
  },
  [SET_Create_Certificate_Of_Completion_ENUMS](state, result) {
    state.create_certificate_of_completion_enums = result
  },
  [SET_Certificate_Of_Completion_PROFILE_ENUMS](state,result){
    state.certificate_of_completion_profile_enums=result
   },
   [SET_Get_Contractors_Contracts](state,result){
     state.get_contractors_contracts=result
   },
   [SET_Get_Tank_ENUMS](state,result){
     state.get_tank_enums=result
   },
   [SET_AVAILABLE_ZONE_ENUMS](state,result){
     state.available_zone_enums=result
   },
  [SET_Certificate_Of_Completion_PROFILE_ENUMS](state, result) {
    state.certificate_of_completion_profile_enums = result
  },
  [SET_Get_Contractors_Contracts](state, result) {
    state.get_contractors_contracts = result
  },
  [SET_Get_Tank_ENUMS](state, result) {
    state.get_tank_enums = result
  },
  [SET_Certificate_Logs](state, result) {
    state.certificate_logs = result
  },
  [SET_Tanker_Type](state, result) {
    state.tanker_type_enums = result
  },
}
